import { ref } from "vue";
import appConfig from "@/config/app.config";

const notifications = ref([]);
let notificationId = 0;

export function useNotification() {
  const addNotification = (message, type = "info", duration = appConfig.notifications.duration) => {
    const id = ++notificationId;

    notifications.value.push({
      id,
      message,
      type,
      visible: true,
    });

    if (duration > 0) {
      setTimeout(() => {
        removeNotification(id);
      }, duration);
    }

    return id;
  };

  const removeNotification = (id) => {
    const index = notifications.value.findIndex((n) => n.id === id);
    if (index > -1) {
      notifications.value.splice(index, 1);
    }
  };

  const success = (message, duration) => addNotification(message, "success", duration);
  const error = (message, duration) => addNotification(message, "error", duration);
  const warning = (message, duration) => addNotification(message, "warning", duration);
  const info = (message, duration) => addNotification(message, "info", duration);

  const confirm = (message) => {
    return new Promise((resolve) => {
      const result = window.confirm(message);
      resolve(result);
    });
  };

  return {
    notifications,
    addNotification,
    removeNotification,
    success,
    error,
    warning,
    info,
    confirm,
  };
}

export { notifications };
